import React, { Component } from 'react';
import { Row, Col } from 'react-flexbox-grid';
import { Menu, Icon } from 'antd';
import { Link } from 'react-router-dom';
import AccountEditModal from 'components/account/AccountEditModal';
import _ from 'lodash';
import { translate } from 'react-i18next';
import { GoogleService } from '../../utils/GoogleService';
import { MetricsCrudService } from '../../utils/MetricsCrudService';
import { GoalCrudService } from '../../utils/GoalCrudService';
import moment from 'moment';
import cookie from 'react-cookies';

class UserMenu extends Component {
	constructor(props) {
		super(props);
		const { i18n } = this.props;
		this.state = {
			userId: _.get(props, 'user.id'),
			role: _.get(props, 'user.role'),
			language: i18n.language
		};
		this.googleService = props.googleService;
		this.handleChangeLanguage = this.handleChangeLanguage.bind(this);
		this.onLogout = this.onLogout.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.user) {
			this.setState({
				userId: _.get(nextProps, 'user.id'),
				role: _.get(nextProps, 'user.role'),
				language: nextProps.i18n.language
			});
		}
	}

	handleChangeLanguage(lng) {
		const { i18n } = this.props;
		console.log('handleChange lang');
		i18n.changeLanguage(lng);
	}

	async fetchActualData() {

		let goal = this.props.user.goal;
		let item = await this.googleService.getReport(goal.profileId, goal.startDate.format('YYYY-MM-DD'), goal.endDate.format('YYYY-MM-DD'));

		let a = [];

		item.result.reports[0].data.rows.map((item) => {
			let month = moment(item.dimensions[0] + '-' + item.dimensions[1] + '-01');
			let value = item.metrics[0].values[0];
			a.push({ month: month, value: value });
		});

		let metricsService = new MetricsCrudService();
		await metricsService.createOrUpdateMetrics(goal, a);

	}

	onLogout() {
         cookie.remove('djutyuser', { path: '/' })
		this.props.onLogouts();
  	}

	render() {
		return (
			<Menu mode="vertical" onClick={this.props.onClick.bind(this)}>
				<Menu.Item key="profile-1">
					<div onClick={this.openModal.bind(this)}>
						<Icon type="user" />
						{this.props.t('usermenu.myAccount')}
					</div>
				</Menu.Item>
				<Menu.Item key="goals-2">
					<Link to="/goals">
						<Icon type="star-o" />
						{this.props.t('usermenu.myGoals')}
					</Link>
				</Menu.Item>
				<Menu.Item key="fetch-actual-data-2">
					<a onClick={() => this.fetchActualData()}>
						<Icon type="sync" />
						{this.props.t('usermenu.fetchActualData')}
					</a>
				</Menu.Item>
				{this.state.role === 'admin' ? (
					<Menu.Item key="users-3">
						<Link to="/users">
							<Icon type="usergroup-add" />
							{this.props.t('usermenu.users')}
						</Link>
					</Menu.Item>
				) : (
					''
				)}
				<Menu.Item key="logout-4">
					<a onClick={() => this.onLogout()}> 
						<Icon type="logout" />
						{this.props.t('usermenu.logout')}
					</a>
				</Menu.Item>
				<Menu.Item key="en-switch">
					<a onClick={() => this.handleChangeLanguage('en')}>English</a>
				</Menu.Item>
				<Menu.Item key="nl-switch">
					<a onClick={() => this.handleChangeLanguage('nl')}>Dutch</a>
				</Menu.Item>
				<AccountEditModal ref={modal => (this.accountEditModal = modal)} user={this.props.user} />
			</Menu>
		);
	}

	openModal() {
		this.accountEditModal.showModal(this.state.userId);
	}
}

export default translate('translations')(UserMenu);



// WEBPACK FOOTER //
// ./src/components/layouts/UserMenu.js